import { FC } from "react";
import { useRecoilValue } from "recoil";

import { apiDataFetchingAtom } from "@ryde/shared";

import { ReportGrid } from "../grid";
import { ReportsWrapperTableStyled } from "../parts";

export const ReportsWrapperTable: FC = () => {
  const isLoading = useRecoilValue(apiDataFetchingAtom);
  return (
    <ReportsWrapperTableStyled>
      {!isLoading && <ReportGrid />}
    </ReportsWrapperTableStyled>
  );
};
